import { defineMessages } from 'react-intl';

type MessageKeys = 'loadMoreButton' | 'hideButton' | 'loadingMoreAgents' | 'noListItemsMessage';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		loadMoreButton: {
			id: 'ai-mate.conversation-assistant-agent.paginated-agents-list.load-more',
			defaultMessage: 'More',
			description: 'Load more button text for paginated agents list',
		},
		hideButton: {
			id: 'ai-mate.conversation-assistant-agent.paginated-agents-list.hide',
			defaultMessage: 'Less',
			description: 'Hide button text to collapse the agents list back to first 5',
		},
		loadingMoreAgents: {
			id: 'ai-mate.conversation-assistant-agent.paginated-agents-list.loading-more-agents',
			defaultMessage: 'loading more agents...',
			description: 'Loading message shown while fetching more agents',
		},
		noListItemsMessage: {
			id: 'ai-mate.conversation-assistant-agent.paginated-agents-list.no-list-items-message',
			defaultMessage: 'Once you favorite an agent, it will appear here.',
			description: 'Message shown when no agents are found in the list after favoriting an agent',
		},
	});

export default message;
